export type Complex = Readonly<{ x: number; y: number }>;
export const TAU = Math.PI * 2;
export const distance = (a: Complex, b: Complex) =>
  Math.hypot(a.x - b.x, a.y - b.y);
export const lerpPoint = (a: Complex, b: Complex, t: number): Complex => ({
  x: a.x + (b.x - a.x) * t,
  y: a.y + (b.y - a.y) * t,
});
